import { combineReducers } from 'redux'
import { handleActions, combineActions } from 'redux-actions'

import { newSearch } from '@/results/store/actions'

import { showJobApplication, closeJobApplication } from '../../jobapplication/store/actions'

import {
  openSearchJobmail,
  closeSearchJobmail,
  subscribe,
  subscribeSuccess,
  subscribeFailure,
  jobmailModalClose,
  jobmailModalOpen
} from './actions'
import {
  DEFAULT_ERRORS,
  DEFAULT_SUBMITTING,
  DEFAULT_SLIDE_IN_ENABLED,
  DEFAULT_SLIDE_IN_PAUSED,
  DEFAULT_MODAL_OPEN,
  DEFAULT_SEARCH_JOBMAIL_STATE
} from './defaultState'

/**
 * @private exposed only for tests
 */
export const errors = handleActions(
  {
    [combineActions(subscribe, subscribeSuccess, newSearch.request)]: () => { },
    [combineActions(subscribeFailure)]: (state, { payload }) => payload
  }, DEFAULT_ERRORS
)

/**
 * @private exposed only for tests
 */
export const searchJobmailState = handleActions({
  [combineActions(closeSearchJobmail, newSearch.request)]: (state) => ({
    ...state, open: false, overlay: false
  }),
  [openSearchJobmail]: (state, { payload = {} }) => ({
    ...DEFAULT_SEARCH_JOBMAIL_STATE,
    ...payload,
    open: true
  }),
  [subscribeSuccess]: (state) => ({
    ...state, visible: false
  })
}, DEFAULT_SEARCH_JOBMAIL_STATE)

/**
 * @private exposed only for tests
 */
export const submitting = handleActions({
  [combineActions(subscribe)]: () => true,
  [combineActions(subscribeFailure, subscribeSuccess)]: () => false
}, DEFAULT_SUBMITTING)

/**
 * @private exposed only for tests
 */
export const slideInEnabled = handleActions({
  [combineActions(closeSearchJobmail)]: () => false,
  [combineActions(newSearch.request)]: () => true
}, DEFAULT_SLIDE_IN_ENABLED)

/**
 * @private exposed only for tests
 */
export const slideInPaused = handleActions({
  [combineActions(showJobApplication, jobmailModalOpen)]: () => true,
  [combineActions(closeJobApplication, jobmailModalClose)]: () => false
}, DEFAULT_SLIDE_IN_PAUSED)

/**
 * @private exposed only for tests
 */
export const modalOpen = handleActions({
  [combineActions(jobmailModalClose, subscribeSuccess)]: () => false,
  [jobmailModalOpen]: () => true
}, DEFAULT_MODAL_OPEN)

export default combineReducers({
  errors,
  searchJobmailState,
  submitting,
  slideInEnabled,
  slideInPaused,
  modalOpen
})
